import { stringify } from '@/helpers/string';
import Client, { shared } from '@shoplinedev/appbridge';

const getUrlParameter = (sParam: string): string | null => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return urlSearchParams.get(sParam);
};

const getUrlParameterJson = (): string => {
  var search = window.location.search.substring(1);
  if (search !== '') {
    var urlParams = JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === '' ? value : decodeURIComponent(value);
    });
    return stringify(urlParams);
  }
  return '';
};

export const config = {
  shop: getUrlParameter('shop') || getUrlParameter('store') || getUrlParameter('handle'),
  urlParams: getUrlParameterJson(),
  embedded: getUrlParameter('embedded'),
  hmac: getUrlParameter('hmac'),
  host: getUrlParameter('host'),
  source: getUrlParameter('source'),
  token: getUrlParameter('token'),
  locale: getUrlParameter('locale'),
  session: getUrlParameter('session'),
  timestamp: getUrlParameter('timestamp'),
  role: getUrlParameter('role'),
  scope: getUrlParameter('scope'),
  appKey: getUrlParameter('appkey'),
};

export const isEmbedded = !['0', 'false'].includes(config.embedded || '');

export const appBridge = Client.createApp({
  appKey: config.appKey || process.env.REACT_APP_API_KEY || '',
  host: shared?.getHost() || '',
});
